import { ReactElement, useId } from 'react';

import { Banner, Body, Content, ExitIcon, ExitIconWrapper, Header, Message } from './styles';
import { BottomBannerSimpleProps } from './types';

const BottomBannerSimple = ({
	onDismiss,
	isOpen,
	title,
	children,
	className,
	innerRef,
	id,
}: BottomBannerSimpleProps): ReactElement | null => {
	const titleId = useId();
	const descriptionId = useId();

	return isOpen ? (
		<Banner
			id={id}
			ref={innerRef}
			aria-labelledby={titleId}
			aria-describedby={descriptionId}
			tabIndex={0}
			className={className}
		>
			<Content>
				<Message>
					<Header id={titleId}>{title}</Header>
					<Body id={descriptionId}>{children}</Body>
				</Message>
				<ExitIconWrapper>
					<ExitIcon onPress={onDismiss} $isDark={false} aria-label="exit" />
				</ExitIconWrapper>
			</Content>
		</Banner>
	) : null;
};

export default BottomBannerSimple;
